import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {Message} from '../types';
import {config} from "../config";

export const EditPageNavigation = ({component}: { component: Message }) => {

    const breadcrumbs = [
        {
            title: 'Home',
            href: '/messages/status/inbox',
        },
        {
            title: config.titles.plural,
            href: `/messages`,
        },
        {
            title: component.id
        }].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
